<template>
  <div class="submenu-container">
    <ul class="submenu-sections">
      <router-link v-if="currentStation.allowTrackUpload" tag="li" :to="{name:'DuplicatesHome', query: $route.query, params: { fileType: 'MUSIC' }}">
        <a>
          <h4><span class="text">Tracks</span></h4>
        </a>
      </router-link>
      <router-link tag="li" :to="{name:'DuplicatesHome', query: $route.query, params: { fileType: 'JINGLE' }}">
        <a>
          <h4><span class="text">Jingles</span></h4>
        </a>
      </router-link>
      <router-link tag="li" :to="{name:'DuplicatesHome', query: $route.query, params: { fileType: 'PODCAST' }}">
        <a>
          <h4><span class="text">Podcasts</span></h4>
        </a>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
  export default {
    name: "PageSubMenuPending"
    ,computed:{
      ...mapState({
        currentStation : state=>state.currentStation ||{},
      })
    }
  }
</script>
